export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/new_courses_thumbnail-a6f25e8f256a6887320420be815137ec.png";